"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FOOTPRINTS_HISTORY_WINDOW_DAYS = exports.DEFAULT_FOOTPRINTS_HISTORY_WINDOW = void 0;
const enums_1 = require("../enums");
exports.DEFAULT_FOOTPRINTS_HISTORY_WINDOW = enums_1.FootprintsHistoryWindow.All;
/** Days of history each window shows; null = no time cutoff. */
exports.FOOTPRINTS_HISTORY_WINDOW_DAYS = {
  [enums_1.FootprintsHistoryWindow.All]: null,
  [enums_1.FootprintsHistoryWindow.OneWeek]: 7,
  [enums_1.FootprintsHistoryWindow.OneMonth]: 30,
  [enums_1.FootprintsHistoryWindow.ThreeMonths]: 90
};
//# sourceMappingURL=footprints.js.map